<div style="cursor:pointer" (click)="updateParentBackLinkClicked()">Test Div Click Back</div>